<app-lfsa-card *ngIf="mostrarCard" [innTemplate]="datosRequisicion" [titulo]="'TRAZABILIDAD PROVEEDORES'" [efecto]="true"
  [colapseName]="'datosRequisicion'" [banderaColapse]='true'></app-lfsa-card>
<ng-template #datosRequisicion>

  <div class="row" *ngIf="!listaVacia">
    <div class="'col-md-12'">
      <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar" id="quickFilter "
        (keyup)="onQuickFilterChanged() " #quickFilter />
    </div>
  </div>

  <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
  <div *ngIf="!loading">
    <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
      No existen datos para la lista de Documentos.
    </div>
    <ag-grid-angular *ngIf="!listaVacia" #agGrid class=" {{empModulo.agGrid.class}}" 
      [ngStyle]="empModulo.agGrid.style" id="{{empModulo.agGrid.id}}" [frameworkComponents]="frameworkComponents "
      [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)"
      [pagination]="true" [paginationPageSize]='15'>
    </ag-grid-angular>
  </div>
  <br>
</ng-template>

<app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
<div *ngIf="!loading" class="row">
  <div class="form-group col-md-6">
    <button [routerLink]="['/emp/administrador/home-emp']"
      class="btn btn-outline-danger btn-block btn-lg">Regresar</button>
  </div>
  <div class="form-group col-md-6">
    <button (click)="descargar()"
      class="btn btn-success btn-block btn-lg">Descargar</button>
  </div>
</div>
